import { SearchAdapter, TopRecommendationsRequest, TopRecommendationsResponse } from '@empathy/search-adapter';
import { container } from '../../../container';
import { DEPENDENCIES } from '../../../container/dependencies.const';
import { EmpathyXConfig } from '../../../models';
import { catchAdapterError, mapWishlistToResults } from '../../../utils';
import { GETTERS_KEYS } from '../../store.const';
import { RECOMMENDATIONS_ACTIONS_KEYS, RECOMMENDATIONS_MUTATIONS_KEYS } from '../recommendations.const';
import { RecommendationsAction, RecommendationsContext } from '../recommendations.interfaces';

export class GetRecommendationsAction implements RecommendationsAction {

  private context: RecommendationsContext;

  actions = {
    [RECOMMENDATIONS_ACTIONS_KEYS.getRecommendations]: (context: RecommendationsContext): void => {
      this.context = context;
      const searchAdapter = container.get<SearchAdapter>(DEPENDENCIES.Adapter);
      const recommendationsRequest: TopRecommendationsRequest = this.getRecommendationsRequest();
      context.commit(RECOMMENDATIONS_MUTATIONS_KEYS.setLoading, true);
      searchAdapter.getTopRecommendations(recommendationsRequest, { requestId: `recommendations-${ context.state.origin }` })
        .then(response => {
          if (response) {
            this.saveRecommendations(response);
          }
        }).catch(catchAdapterError('Recommendations', {}));
    }
  };

  protected getRecommendationsRequest(): TopRecommendationsRequest {
    const { rootGetters, rootState, state } = this.context;
    const { recommendations }: EmpathyXConfig = rootGetters[GETTERS_KEYS.config.config];
    return {
      rows: recommendations.pageSize * state.page,
      origin: state.origin,
      query: rootState.search.query || undefined
    };
  }

  protected saveRecommendations(response: TopRecommendationsResponse) {
    const { commit, rootState } = this.context;
    mapWishlistToResults(rootState.core.wishlist, response.results);
    commit(RECOMMENDATIONS_MUTATIONS_KEYS.saveRecommendations, response.results);
    commit(RECOMMENDATIONS_MUTATIONS_KEYS.setLoading, false);
  }
}
